export interface ZbResponse<T> {
    responseData : T;
    statusCode: number;
    errors?: Array<string>;
    warnings?: Array<string>;
    success?: boolean;
}

export enum ZbResponseStatusCodes{
    OK = 200,
    ERROR = 500
}